import {
  LOADING_PERMISSION,
  SAVE_PERMISSION,
  SAVE_USER_PERMISSION
} from "appRedux/constants";

const INIT_STATE = {
  permissions: [],
  permission_loading: false,
  user_permissions: []
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case LOADING_PERMISSION: {
      return {
        ...state,
        permission_loading: true
      };
    }
    case SAVE_PERMISSION: {
      return {
        ...state,
        permission_loading: false,
        permissions: action.payload
      };
    }
    case SAVE_USER_PERMISSION: {
      return {
        ...state,
        permission_loading: false,
        user_permissions: action.payload
      };
    }
    default:
      return state;
  }
};
